module.exports = [{
      plugin: require('/home/vsts/work/1/s/node_modules/gatsby-plugin-sentry/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://81498dc0317e47d49d9c915fb53e5764@sentry.io/1540879","environment":"production"},
    },{
      plugin: require('/home/vsts/work/1/s/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
